import { useEffect } from 'react';

import { useStores } from '../stores/useStores';

export const useThemeByCoinType = () => {
  const { coinTypeStore } = useStores();

  useEffect(() => {
    const { body } = document;

    if (coinTypeStore.coinType === 'SC') {
      body.setAttribute('data-theme', 'green');
    } else {
      body.setAttribute('data-theme', 'yellow');
    }

    return () => {
      body.setAttribute('data-theme', 'yellow');
    };
  }, [coinTypeStore.coinType]);
};
